import { Shield, ShieldCheck, FileText, AlertTriangle, Users, ScanSearch, Layers, Briefcase, BarChart3, ClipboardCheck, BookOpenCheck, Cog, GraduationCap, Network, ServerCog, Sparkles, ChevronRight, Radar } from "lucide-react";
import { NavLink, useLocation } from "react-router-dom";
import { useState } from "react";

const NAV = [
  { group: "Overview", items: [
    { to: "/dashboard", label: "Compliance Dashboard", icon: BarChart3 },
    { to: "/my-work", label: "My Work", icon: Briefcase },
  ]},
  { group: "Customers & Onboarding", items: [
    { to: "/customers", label: "Customers", icon: Users },
    { to: "/kyc", label: "KYC Queue", icon: ClipboardCheck },
    { to: "/beneficial-ownership", label: "Beneficial Ownership", icon: Network },
  ]},
  { group: "Screening", items: [
    { to: "/screening", label: "Sanctions & PEP", icon: ScanSearch },
    { to: "/screening/watchlists", label: "Watchlists", icon: Shield },
    { to: "/screening/adverse-media", label: "Adverse Media", icon: AlertTriangle },
  ]},
  { group: "Monitoring", items: [
    { to: "/transaction-screening", label: "Transaction Screening", icon: ShieldCheck },
    { to: "/transactions", label: "Transactions", icon: Layers },
    { to: "/customer-sweep", label: "Customer Base Sweep", icon: Radar },
    { to: "/alerts", label: "Alerts", icon: AlertTriangle },
    { to: "/analytics", label: "Behavioural Analytics", icon: BarChart3 },
  ]},
  { group: "Cases", items: [
    { to: "/cases", label: "Active Cases", icon: Briefcase },
    { to: "/cases?owner=me", label: "My Cases", icon: ClipboardCheck },
  ]},
  { group: "Reporting", items: [
    { to: "/reporting/str", label: "STR", icon: FileText },
    { to: "/reporting/ctr", label: "CTR", icon: FileText },
    { to: "/reporting/ftr", label: "FTR", icon: FileText },
    { to: "/reporting/board", label: "Board Reports", icon: BookOpenCheck },
  ]},
  { group: "Models", items: [
    { to: "/models", label: "Model Inventory", icon: Sparkles },
    { to: "/atom-explainer", label: "Atom Explainer", icon: Sparkles },
  ]},
  { group: "Governance", items: [
    { to: "/governance/audit-log", label: "Audit Log", icon: ClipboardCheck },
    { to: "/governance/access", label: "Access Control", icon: Shield },
    { to: "/governance/examination-readiness", label: "Examination Readiness", icon: BookOpenCheck },
    { to: "/governance/culture", label: "Compliance Culture", icon: GraduationCap },
  ]},
  { group: "Integration", items: [
    { to: "/integrations", label: "Connections", icon: ServerCog },
  ]},
  { group: "Settings", items: [
    { to: "/settings", label: "Institution & Thresholds", icon: Cog },
  ]},
];

export default function Sidebar() {
  const loc = useLocation();
  return (
    <aside data-testid="app-sidebar" className="w-[244px] shrink-0 bg-navy grain-dark text-white flex flex-col h-screen sticky top-0 border-r border-navy-800">
      <div className="px-4 py-4 border-b border-white/8">
        <div className="flex items-center gap-2">
          <div className="w-7 h-7 rounded-lg bg-amber/20 border border-amber/40 flex items-center justify-center">
            <div className="grid grid-cols-3 gap-[2px] w-3.5 h-3.5">
              {[1,1,1, 1,0,1, 1,1,1].map((v,i) => <span key={i} className={`w-1 h-1 ${v ? 'bg-amber' : 'bg-transparent'}`} />)}
            </div>
          </div>
          <span className="display text-white font-semibold text-[15px] tracking-tightest">Atom</span>
          <span className="text-white/55 text-[12px] tracking-tight">AML Solution</span>
        </div>
        <div className="text-[10px] text-white/50 mt-1.5 tracking-wide pl-9">COMPLIANCE WORKSPACE</div>
      </div>
      <nav className="flex-1 overflow-y-auto sidebar-scroll py-3">
        {NAV.map((group) => (
          <div key={group.group} className="mb-3">
            <div className="px-4 text-[10px] uppercase tracking-[0.08em] text-white/40 font-medium mb-1.5">
              {group.group}
            </div>
            {group.items.map((it) => {
              const Icon = it.icon;
              const active = loc.pathname === it.to.split("?")[0] || (it.to !== "/" && loc.pathname.startsWith(it.to.split("?")[0]) && it.to.split("?")[0] !== "/dashboard");
              return (
                <NavLink
                  key={it.to}
                  to={it.to}
                  data-testid={`nav-${it.to.replace(/[\/?=]/g, "-")}`}
                  className={({ isActive }) =>
                    `flex items-center gap-2.5 pl-3.5 pr-2 py-1.5 text-[13px] relative tracking-tight transition-colors ${
                      (isActive || active) ? "bg-navy-800 text-white" : "text-white/75 hover:bg-white/6 hover:text-white"
                    }`
                  }
                >
                  {({ isActive }) => (
                    <>
                      {(isActive || active) && (
                        <span className="absolute left-0 top-0 bottom-0 w-[3px] bg-amber" />
                      )}
                      <Icon size={15} strokeWidth={1.25} className="shrink-0" />
                      <span className="truncate">{it.label}</span>
                    </>
                  )}
                </NavLink>
              );
            })}
          </div>
        ))}
      </nav>
      <div className="px-3 py-2.5 border-t border-white/8 text-[10px] text-white/40 tracking-wide">
        v1.0 · Atom AML Solution
      </div>
    </aside>
  );
}
